import AxiosUser from './axios_manage_flashsale_api'

const ModuleManageFlashSale = {
  state: {
    // flashSale
    stateCreateFlashSale: [],
    stateGetFlashSale: [],
    stateGetListProductDetail: [],
    stateDeleteFlashSale: [],
    stateUpdateFlashSale: [],
    stateListAllShopProductFlashSale: [],
    stateListFlashSaleV2: [],
    stateCreateFlashSaleV2: [],
    stateEditFlashSaleV2: [],
    stateSelectListProductFlashSale: [],
    stateCopyFlashSale: [],
    stateDetailFlashSale: [],
    stateFlashSaleType: [],
    stateUpdateStatusFlashSale: [],
    stateDeleteStatusFlashSale: []
  },
  mutations: {
    // flashSale
    mutationsCreateFlashSale (state, data) {
      state.stateCreateFlashSale = data
    },
    mutationsGetFlashSale (state, data) {
      state.stateGetFlashSale = data
    },
    mutationsGetListProductDetail (state, data) {
      state.stateGetListProductDetail = data
    },
    mutationsDeleteFlashSale (state, data) {
      state.stateDeleteFlashSale = data
    },
    mutationsUpdateFlashSale (state, data) {
      state.stateUpdateFlashSale = data
    },
    mutationsListAllShopProductFlashSale (state, data) {
      state.stateListAllShopProductFlashSale = data
    },
    mutationsListFlashSaleV2 (state, data) {
      state.stateListFlashSaleV2 = data
    },
    mutationsCreateFlashSaleV2 (state, data) {
      state.stateCreateFlashSaleV2 = data
    },
    mutationsEditFlashSaleV2 (state, data) {
      state.stateEditFlashSaleV2 = data
    },
    mutationsSelectListProductFlashSale (state, data) {
      state.stateSelectListProductFlashSale = data
    },
    mutationsCopyFlashSale (state, data) {
      state.stateCopyFlashSale = data
    },
    mutationsDetailFlashSale (state, data) {
      state.stateDetailFlashSale = data
    },
    mutationsFlashSaleType (state, data) {
      state.stateFlashSaleType = data
    },
    mutationsUpdateStatusFlashSale (state, data) {
      state.stateUpdateStatusFlashSale = data
    },
    mutationsDeleteStatusFlashSale (state, data) {
      state.stateDeleteStatusFlashSale = data
    }
  },
  actions: {
    // flashSale
    async actionsCreateFlashSale (context, access) {
      const responseData = await AxiosUser.CreateFlashSale(access)
      // console.log('response', responseData)
      await context.commit('mutationsCreateFlashSale', responseData)
    },
    async actionsGetFlashSale (context, access) {
      const responseData = await AxiosUser.GetFlashSale(access)
      // console.log('response', responseData)
      await context.commit('mutationsGetFlashSale', responseData)
    },
    async actionsGetListProductDetail (context, access) {
      const responseData = await AxiosUser.GetListProductDetail(access)
      // console.log('response', responseData)
      await context.commit('mutationsGetListProductDetail', responseData)
      // await context.commit('mutationsGetFlashSale', responseData)
    },
    async actionsDeleteFlashSale (context, access) {
      const responseData = await AxiosUser.DeleteFlashSale(access)
      await context.commit('mutationsDeleteFlashSale', responseData)
    },
    async actionsUpdateFlashSale (context, access) {
      const responseData = await AxiosUser.UpdateFlashSale(access)
      await context.commit('mutationsUpdateFlashSale', responseData)
    },
    async actionsListAllShopProductFlashSale (context, access) {
      const responseData = await AxiosUser.ListAllShopProductFlashSale(access)
      await context.commit('mutationsListAllShopProductFlashSale', responseData)
    },
    async actionsListFlashSaleV2 (context, access) {
      var responseData = await AxiosUser.ListFlashSaleV2(access)
      await context.commit('mutationsListFlashSaleV2', responseData)
    },
    async actionsCreateFlashSaleV2 (context, access) {
      var responseData = await AxiosUser.CreateFlashSaleV2(access)
      await context.commit('mutationsCreateFlashSaleV2', responseData)
    },
    async actionsEditFlashSaleV2 (context, access) {
      var responseData = await AxiosUser.EditFlashSaleV2(access)
      await context.commit('mutationsEditFlashSaleV2', responseData)
    },
    async actionsSelectListProductFlashSale (context, access) {
      var responseData = await AxiosUser.SelectListProductFlashSale(access)
      await context.commit('mutationsSelectListProductFlashSale', responseData)
    },
    async actionsCopyFlashSale (context, access) {
      var responseData = await AxiosUser.CopyFlashSale(access)
      await context.commit('mutationsCopyFlashSale', responseData)
    },
    async actionsDetailFlashSale (context, access) {
      var responseData = await AxiosUser.DetailFlashSale(access)
      await context.commit('mutationsDetailFlashSale', responseData)
    },
    async actionsFlashSaleType (context, access) {
      var responseData = await AxiosUser.FlashSaleType(access)
      await context.commit('mutationsFlashSaleType', responseData)
    },
    async actionsUpdateStatusFlashSale (context, access) {
      var responseData = await AxiosUser.UpdateStatusFlashSale(access)
      await context.commit('mutationsUpdateStatusFlashSale', responseData)
    },
    async actionsDeleteStatusFlashSale (context, access) {
      var responseData = await AxiosUser.DeleteStatusFlashSale(access)
      await context.commit('mutationsDeleteStatusFlashSale', responseData)
    }
  }
}
export default ModuleManageFlashSale
